import React from 'react'

const Stop = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M9.75 5.4165H7.58333C6.98502 5.4165 6.5 5.90153 6.5 6.49984V19.4998C6.5 20.0981 6.98502 20.5832 7.58333 20.5832H9.75C10.3483 20.5832 10.8333 20.0981 10.8333 19.4998V6.49984C10.8333 5.90153 10.3483 5.4165 9.75 5.4165Z" fill="currentColor" fillOpacity="0.25" stroke="currentColor" strokeLinecap="round" strokeWidth="1.3"></path>
<path d="M18.4167 5.4165H16.25C15.6517 5.4165 15.1667 5.90153 15.1667 6.49984V19.4998C15.1667 20.0981 15.6517 20.5832 16.25 20.5832H18.4167C19.015 20.5832 19.5 20.0981 19.5 19.4998V6.49984C19.5 5.90153 19.015 5.4165 18.4167 5.4165Z" fill="currentColor" fillOpacity="0.25" stroke="currentColor" strokeLinecap="round" strokeWidth="1.3"></path>
</svg>
    )
}

export default Stop
